import styled from "styled-components";

/**
 * Área do DatePicker
 * Define o layout principal do seletor de datas.
 */
export const DatePickerArea = styled.div`
  border-radius: ${({ theme }) => theme.spacing(4.5)};
  box-shadow: ${({ theme }) => theme.shadows.light.medium};
  background-color: ${({ theme }) => theme.colors.white};
  min-width: ${({ theme }) => theme.spacing(112)};
  top: ${({ theme }) => theme.spacing(9)};
  left: ${({ theme }) => theme.spacing(-6)};
  position: absolute;
  z-index: 1;
`;

export const Calendars = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
`;

export const CalendarMonth = styled.div`
  min-width: ${({ theme }) => theme.spacing(54)};
`;

/**
 * Cabeçalho do DatePicker
 * Exibe o título no topo do seletor.
 */
export const DatePickerHeader = styled.div`
  padding: ${({ theme }) => theme.spacing(2)};
  gap: ${({ theme }) => theme.spacing(1.5)};
  flex-direction: column;
  display: flex;
`;

export const CalendarInstruction = styled.p`
  margin: 0;
  padding: 0 ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
`;

export const SelectionModeTabs = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.spacing(0.5)};
  border-radius: ${({ theme }) => theme.spacing(1.25)};
  background-color: ${({ theme }) => theme.colors.lightGray};
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;

export const SelectionModeButton = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== "isActive",
})<{ isActive?: boolean }>`
  min-height: ${({ theme }) => theme.spacing(5)};
  padding: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(2)};
  border: 2px solid
    ${({ isActive, theme }) =>
      isActive ? theme.colors.primaryColor : "transparent"};
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.spacing(1)};
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colors.white : "transparent"};
  box-shadow: ${({ isActive }) =>
    isActive ? "0 1px 4px rgba(0, 0, 0, 0.12)" : "none"};
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  cursor: ${({ isActive }) => (isActive ? "default" : "pointer")};
`;
